import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

// El secreto de un token solo existe en la respuesta que lo genera o lo rota.
// Este modal es la unica oportunidad del administrador para copiarlo.
const TokensExternosTokenModal = ({ abierto, token, onCerrar }) => {
  const [copiado, setCopiado] = useState(false);

  const copiar = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(token);
    }
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2500);
  };

  return (
    <Modal isOpen={abierto} size="lg" backdrop="static" keyboard={false}>
      <ModalHeader>Token generado</ModalHeader>
      <ModalBody>
        <div className="alert alert-warning">
          <i className="fa fa-exclamation-triangle mr-2" />
          Cópialo ahora. Por seguridad no se guarda en claro y no volverá a mostrarse. Si lo pierdes tendrás que re-generar el token.
        </div>

        <div className="input-group mb-3">
          <input type="text" className="form-control" readOnly value={token || ''} style={{ fontFamily: 'monospace' }} />
          <div className="input-group-append">
            <button type="button" className="btn btn-outline-secondary" onClick={copiar}>
              <i className={`fa ${copiado ? 'fa-check' : 'fa-copy'} mr-1`} />
              {copiado ? 'Copiado' : 'Copiar'}
            </button>
          </div>
        </div>

        <small className="text-muted">
          Las peticiones deben llegar desde los dominios autorizados: el navegador envía la cabecera <code>Origin</code> por su cuenta; una
          integración de servidor a servidor debe enviarla explícitamente.
        </small>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-sirio" onClick={onCerrar}>
          Ya lo copié, cerrar
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default TokensExternosTokenModal;
